// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"af6cdcc4","144":"f317ab78","202":"95711010","252":"ff1704cb","292":"dce714ed","610":"933d8026","626":"6daa9065","821":"541a6c07","873":"4d92306d"}[chunkId] + ".chunk.js";
};